export const formatTime = (seconds: number) => {
  if (seconds > 0 && seconds < 60) {
    return '1m'
  }
  const h = Math.floor(seconds / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  if (h > 0) {
    return `${h}h:${m}m`
  }
  return `${m}m`
}
